<template>
<!-- 交易详情 -->
    <div  class="Booking">
        <TopNavigation  class="topNavigation"></TopNavigation>
        <div class="typeArea">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'UserInfo', params: { menuInx: '5' } }">我的钱包</el-breadcrumb-item>
                <el-breadcrumb-item class="bread">交易详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="con">
                <div class="con-tit">
                    订单信息
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            订单编号
                        </div>
                        <div class="nr-c">
                            {{detailFotm.sn}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            订单类型
                        </div>
                        <div class="nr-c">
                            {{detailFotm.type_desc}}
                            <!-- {{ detailFotm.change_type == 201 ? '余额充值' : '余额提现' }} -->
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            交易金额
                        </div>
                        <div class="nr-c">
                            <!-- {{detailFotm.action==1?'+':'-'}} -->
                            ￥{{detailFotm.change_amount}}
                        </div>
                    </div>
                    <div class="nr nryi" v-if="detailFotm.change_object ==1">
                        <div class="nr-t">
                            交易渠道
                        </div>
                        <div class="nr-c dongjie">
                            <div v-if="detailFotm.pay_way==2">微信支付</div>
                            <div v-if="detailFotm.pay_way==3">支付宝支付</div>
                            <div v-if="detailFotm.pay_way==4">
                                对公转账
                                <span @click="dialogVisible = true">查看支付凭证</span>
                            </div>
                            
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            交易状态
                        </div>
                        <div class="nr-c">
                            {{detailFotm.descA}}
                            <!-- <span v-if="transactionStatus==0">审核中</span>
                            <span v-if="transactionStatus==1">已支付</span>
                            <span v-if="transactionStatus==2">已退款</span>
                            <span v-if="transactionStatus==3">已驳回</span>
                            <span v-if="transactionStatus==4">冻结中</span>
                            <span v-if="transactionStatus==5">已解冻</span> -->
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            交易时间
                        </div>
                        <div class="nr-c">
                            {{detailFotm.create_time}}
                        </div>
                    </div>
                    <div class="nr nryi" v-if="detailFotm.statusA==3">
                        <div class="nr-t">
                            驳回时间
                        </div>
                        <div class="nr-c">
                            {{detailFotm.check_time || '--'}}
                        </div>
                    </div>
                </div>
                <div class="neirong"  v-if="detailFotm.statusA==3">
                    <div class="nr">
                        <div class="nr-t">
                            驳回原因
                        </div>
                        <div class="nr-c nr-csan">
                            {{detailFotm.check_reason}}
                        </div>
                    </div>
                </div>
                <div class="con-tit">
                    操作人
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            操作人昵称
                        </div>
                        <div class="nr-c">
                            {{check_admin.name || '--'}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            操作人账号
                        </div>
                        <div class="nr-c">
                            {{check_admin.account || '--'}}
                        </div>
                    </div>
                </div>
                <!-- <div class="con-tit" v-if="detailFotm.change_object==2">
                    提现账号
                </div>
                <div class="neirong" v-if="detailFotm.change_object==2">
                    <div class="nr">
                        <div class="nr-t">
                            银行账号
                        </div>
                        <div class="nr-c">
                            213214251231232132
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            开户行
                        </div>
                        <div class="nr-c">
                            中国人民银行敦煌支行
                        </div>
                    </div>
                </div> -->
            </div>
        </div>

        <!-- 查看对公转账支付凭证 -->
        <el-dialog
            title="对公转账支付凭证"
            :visible.sync="dialogVisible">
            <div>
                <img class="tupian" :src="detailFotm.voucher_file" alt="">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
    
<script>
import TopNavigation from "../HP/TopNavigationB.vue";
import { accountLogDetails } from "@/api/api";
export default {
    components:{
        TopNavigation,
    },
    data() {
        return {
            // 交易状态
            // 0 审核中  1 已支付  2 已退款  3 已驳回  4 冻结中  5 已解冻
            transactionStatus:0,
            detailFotm:{},
            headers:{
                'token':localStorage.getItem('token')
            },
            dialogVisible: false,
            // 审核人信息
            check_admin:{
                name:'',
                account:'',
            },
        }
    },
    methods: {
        async getDetail(){
            try {
                const res = await accountLogDetails({
                    id:this.$route.query.id
                },this.headers)
                if(res.code==1){
                    this.detailFotm = res.data
                    this.detailFotm.descA = this.detailFotm.deal_status.desc
                    this.detailFotm.statusA = this.detailFotm.deal_status.status
                    if(this.detailFotm.check_admin.name!=undefined){
                        this.check_admin.name = this.detailFotm.check_admin.name
                    }
                    if(this.detailFotm.check_admin.account!=undefined){
                        this.check_admin.account = this.detailFotm.check_admin.account
                    }
                }
            } catch (error) {
                console.log(error,'提现详情获取失败');
            }
        }
    },
    mounted(){
        this.getDetail()
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.Booking{
    background: #F9F9F9;
}
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}


.el-breadcrumb{
    margin: 20px 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .el-breadcrumb__inner is-link{
        color: pink;
    }
}

:deep(.el-breadcrumb){
    .el-breadcrumb__inner{
        color: #999999 !important;
    }
    .bread{
        span{
            color: #0073F5 !important;
        }
    }
}

.con{
    // height: 888px;
    background: #FFFFFF;
    border-radius: 12px 12px 12px 12px;
    padding: 32px;
    box-sizing: border-box;

    .con-tit{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        padding-top: 12px;
        padding-bottom: 24px;

    }

    .neirong{
        display: flex;
        margin-bottom: 20px;
        .nr{
            display: flex;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            font-style: normal;
            text-transform: none;
        }

        .nryi{
          margin-left: 40px;  
        }


        .nr-t{
            width: 85px;
            height: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #606260;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin-top: 10px;
        }

        .nr-c{
            width: 260px;
            height: 40px;
            background: #F9F9F9;
            border-radius: 9px 9px 9px 9px;
            
            padding: 10px 12px;

            box-sizing: border-box;
        }
        .nr-csan{
            width: 1044px;
            height: 200px;
            margin: 0;
        }
        .dongjie{
            display: flex;
            align-items: center;
            span{
                display: inline-block;
                cursor: pointer;
                // width: 48px;
                padding: 0 8px;
                height: 20px;
                background: #EDF6FF;
                border-radius: 4px 4px 4px 4px;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 10px;
                color: #0073F5;
                line-height: 20px;
                text-align: center;
                font-style: normal;
                text-transform: none;

                margin-left: 8px;
            }
        }
    }
}
.el-icon-user-solid{
    font-size: 40px;
    line-height: 60px;
}

.tupian{
    width: 100%;
}
</style>